import ContactSlide from './ContactSlide'
import CrossBreakSlide from './CrossBreakSlide'
import DerivedImportanceSlide from './DerivedImportanceSlide'
import ExecutiveSummarySlide from './ExecutiveSummarySlide'
import ExploriBenchmarksExplainedSlide from './ExploriBenchmarksExplainedSlide'
import ExploriCorrelationExplainedSlide from './ExploriCorrelationExplainedSlide'
import InheritedQuestionSlide from './InheritedQuestionSlide'
import LoyaltyMatrixSlide from './LoyaltyMatrixSlide'
import NetPromoterExplainedSlide from './NetPromoterExplainedSlide'
import OverallScoreSlide from './OverallScoreSlide'
import ProjectSpecSlide from './ProjectSpecSlide'
import QuestionSlide from './QuestionSlide'

export const questionToSlide = (pageQuestionId, question, benchmarks, comparisonSurveyIds, chartType, rankType) => {
    return new QuestionSlide({
        pageQuestionId,
        benchmarks,
        chartType,
        comparisonSurveyIds,
        ranking: rankType,
        question,
    })
}
